var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / Email",
    clipPath: "url(#clip0_118_517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 3.00391H21C21.2652 3.00391 21.5196 3.10926 21.7071 3.2968C21.8946 3.48434 22 3.73869 22 4.00391V20.0039C22 20.2691 21.8946 20.5235 21.7071 20.711C21.5196 20.8986 21.2652 21.0039 21 21.0039H3C2.73478 21.0039 2.48043 20.8986 2.29289 20.711C2.10536 20.5235 2 20.2691 2 20.0039V4.00391C2 3.73869 2.10536 3.48434 2.29289 3.2968C2.48043 3.10926 2.73478 3.00391 3 3.00391ZM12.06 11.6869L5.648 6.24191L4.353 7.76591L12.073 14.3209L19.654 7.76091L18.346 6.24791L12.061 11.6869H12.06Z",
    fill: "#FFA3A3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_118_517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.00390625)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.d59414895858ac40101d4c15e35169d6.svg";
export { ForwardRef as ReactComponent };